import React, { FC, useEffect } from 'react';

import Modal from '~components/atoms/Modal';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch } from '~redux/hooks';

import CreateInventoryForm from '../CreateInventoryForm';

type CreateInventoryModalProps = {
    isOpen: boolean;
    onClose: () => void;
}

const CreateInventoryModal: FC<CreateInventoryModalProps> = ({
    isOpen,
    onClose,
}) => {

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!isOpen) {
            dispatch(combinedActions.goldClearCreateInventoryParams());
            dispatch(combinedActions.silverClearCreateInventoryParams());
        }
    }, [isOpen]);

    return (
        <Modal
            testId='create-inventory-modal-close'
            isOpen={isOpen}
            onClose={onClose}
            title='Create New Inventory'
        >
            <CreateInventoryForm />
        </Modal>
    );
};

export default CreateInventoryModal;
